var path = 'src/app/patients/navigation/cohort-navigation.html';
var html = "<div class=patient-nav> <ul> <li class=group ui-sref-active=active> <a ui-sref=\"patient.cohort({patientId: patient.id, cohortId: cohort.id})\" class=no-link><span class=link>{{cohort.shortName}}</span> <i class=\"fa fa-info-circle\"></i></a> </li> <li ui-sref-active=active ng-repeat=\"item in items\"> <a ui-sref={{item.state}}>{{item.name}}</a> </li> </ul> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/patients/navigation/cohort-navigation.html
// module id = 513
// module chunks = 0